import {
  useDataProvider,
  useListContext,
  useResourceContext,
} from "react-admin";
import { useQuery } from "react-query";

const useGrandTotal = (subUri = "grand-total", filter = {}, options = {}) => {
  const resource = useResourceContext();
  const dataProvider = useDataProvider();
  const { filterValues } = useListContext();

  const ifCtx = { ...filterValues, ...filter };

  const resourceFilter =
    resource +
    "/" +
    subUri +
    (ifCtx ? "?filter=" + encodeURIComponent(JSON.stringify(ifCtx)) : "");

  return useQuery(
    [resourceFilter, "getListNoParams"],
    () => dataProvider.getListNoParams(resourceFilter),
    options
  );
};

export default useGrandTotal;
